'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dIdentifier$0024 from "./presto.types$-Account-Identifier$.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024 from "./presto.types$-Account-Name$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dPassword$0024 from "./presto.types$-Password$.js";
import * as $j_presto$002etypes$0024$002dTurnstile$002dToken$0024 from "./presto.types$-Turnstile-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$2(outer) {
  this.btU = null;
  this.btS = null;
  this.btT = false;
  this.btQ = null;
  this.btR = false;
  this.btV = false;
  this.btW = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.btU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_RegisterPageView$$anon$2 as $c_Lpresto_RegisterPageView$$anon$2 };
$p = $c_Lpresto_RegisterPageView$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$2;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$2() {
}
export { $h_Lpresto_RegisterPageView$$anon$2 as $h_Lpresto_RegisterPageView$$anon$2 };
$h_Lpresto_RegisterPageView$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.btU;
});
$p.t = (function() {
  if ((!this.btT)) {
    this.btS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("password", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("identifier", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.btT = true;
  }
  return this.btS;
});
$p.ae = (function() {
  if ((!this.btR)) {
    this.btQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().p8(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPassword$0024.$m_Lpresto_types$Password$().cs5(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dName$0024.$m_Lpresto_types$AccountName$().cs0(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dAccount$002dIdentifier$0024.$m_Lpresto_types$AccountIdentifier$().cHS()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTurnstile$002dToken$0024.$m_Lpresto_types$TurnstileToken$().cIp(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.btR = true;
  }
  return this.btQ;
});
$p.w = (function() {
  if ((!this.btW)) {
    this.btV = false;
    this.btW = true;
  }
  return this.btV;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_RegisterPageView$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$2, "presto.RegisterPageView$$anon$2", ({
  Q0: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$2 as $d_Lpresto_RegisterPageView$$anon$2 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$2.js.map
